import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Es necesario que mi esposo/a participe?',
    a: 'No, tu fe y tu autoridad son suficientes para comenzar la limpieza.'
  }, {
    q: '¿Qué tipo de aceite necesito?',
    a: 'Aceite de oliva común, consagrado por ti en oración.'
  }, {
    q: '¿Cuánto tiempo toma leerlo?',
    a: 'Es una guía práctica de lectura rápida (45 min) para aplicar de inmediato.'
  }];
  return <section className="py-24 px-6 bg-white" data-id="element-24">
      <div className="max-w-3xl mx-auto" data-id="element-25">
        <FadeIn data-id="element-26">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center text-brown-900" data-id="element-27">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-28">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} delay={index * 0.1} data-id="element-29" />)}
          </div>
        </FadeIn>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer,
  delay
}: {
  question: string;
  answer: string;
  delay: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <FadeIn delay={delay} data-id="element-30">
      <div className="border border-cream-200 rounded-lg overflow-hidden bg-cream-50/50" data-id="element-31">
        <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-32">
          <span className="text-lg font-bold text-brown-900 font-serif" data-id="element-33">
            {question}
          </span>
          <ChevronDown className={`w-5 h-5 text-gold-500 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-34" />
        </button>
        <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-35">
          <p className="text-brown-800 text-lg" data-id="element-36">{answer}</p>
        </div>
      </div>
    </FadeIn>;
}